import { render, staticRenderFns } from "./admissionRequestsView.vue?vue&type=template&id=889cb7d0&scoped=true&"
import script from "./admissionRequestsView.vue?vue&type=script&lang=js&"
export * from "./admissionRequestsView.vue?vue&type=script&lang=js&"
import style0 from "./admissionRequestsView.vue?vue&type=style&index=0&id=889cb7d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889cb7d0",
  null
  
)

export default component.exports